module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eb965ba88ced446fbd45955fe708beba.png";